const fruits = [
  { id: 1, name: "Organic Apple", price: 120, image: "/images/apple.png" },
  { id: 2, name: "Fresh Banana", price: 60, image: "/images/banana.jpg" },
  { id: 3, name: "Juicy Mango", price: 150, image: "/images/mango.jpg" },
  { id: 4, name: "Sweet Orange", price: 90, image: "/images/orange.jpg" },
  { id: 5, name: "Fresh Pomegranate", price: 80, image: "/images/anar.jpg" },
  { id: 6, name: "Jucy Black Berries", price: 200, image: "/images/black.jpg" },
  { id: 7, name: "Dragon Fruit", price: 500, image: "/images/dragon.jpg" },
  { id: 8, name: "Healthy Kiwi", price: 250, image: "/images/kiwi.jpg" },
];
export default fruits;
